import { Client } from '@/pages/user/api';

const apiPrefix = 'portal';

export const GetCurrentPsSupplierDetail = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/ps/supplier/detail',
  });
};

export const GetPsSupplierAdminDetail = async (data: { enterpriseSn: string }): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/ps/admin/supplier/detail',
    data,
  });
};

export const UpdateCurrentPsSupplier = async (data: any): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/ps/supplier/update',
    data,
  });
};
